import { GetUserPropsType } from '../../../typings';

import { apiConfig } from '../config';
import { getFetch } from '../fetch';

export function getUserProps(
): Promise<GetUserPropsType> {
    const { apiGetUserProps } = apiConfig.getStaticUrls();

    return getFetch(apiGetUserProps);
}
